import React, { useMemo, useState } from 'react';
import { PageDialogContent, PageDialogFooter } from '../../components/dialog';
import BotchatWindow from './botchatWindow';
import ChangeDetailsForm from './changeDetailForm';
import BotchatFooter from './chatFooter';


const ChatbotPopup = React.memo(({
    closeChatbotPopup
}) => {

    const [msgDetail, setMsgDetail] = useState({});
    const [readyToSend, setReadyToSend] = useState(null);

    const onStartBotChat = (values) => {
        setMsgDetail(values)
    }


    return(
        <>
            <PageDialogContent
            contentCls="pt-2 pt-2 px-2"
            hideOverFlow={true}
            contentScroll={false}
            >
                <div className="max-h-[70vh] overflow-hidden pb-12">
                    {!msgDetail?.description ?
                        <ChangeDetailsForm onStartBotChat={onStartBotChat} />
                        :
                        <BotchatWindow msgDetail={msgDetail} setReady={setReadyToSend} />
                    }
                </div>
            </PageDialogContent>
            {msgDetail?.description ?
                <PageDialogFooter>
                    <BotchatFooter setMsgDetail={setMsgDetail} msgDetail={msgDetail} summaryForProvider={readyToSend} closeChatbotPopup={closeChatbotPopup} />
                </PageDialogFooter>
            : null
            }
        </>
    )
})

export default ChatbotPopup;